export default {
  data() {
    return {
      multiChartData: null,
      proposalsData: {
        series: [
          {
            data: [
              76.0,
              73.0,
              92.0,
              30.0,
              43.0,
              22.0,
              93.0,
              29.0,
              76.0,
              73.0,
              92.0,
              30.0,
              83.0,
              22.0,
              93.0,
              29.0,
              76.0,
              73.0,
              92.0,
              30.0,
              63.0,
              22.0,
              93.0,
              29.0
            ],
            name: "Project One",
            type: "column"
          },
          {
            data: [
              10.0,
              55.0,
              44.0,
              49.0,
              57.0,
              53.0,
              57.0,
              38.0,
              10.0,
              55.0,
              44.0,
              49.0,
              57.0,
              53.0,
              57.0,
              38.0,
              55.0,
              44.0,
              49.0,
              57.0,
              53.0,
              57.0,
              38.0,
              89.0
            ],
            name: "Project Two",
            type: "column"
          },
          {
            data: [
              20.0,
              30.0,
              12.0,
              18.0,
              25.0,
              31.0,
              21.0,
              39.0,
              20.0,
              30.0,
              12.0,
              18.0,
              25.0,
              31.0,
              21.0,
              39.0,
              20.0,
              30.0,
              12.0,
              18.0,
              25.0,
              31.0,
              21.0,
              39.0
            ],
            name: "Project Three",
            type: "column"
          }
        ],
        x_axis: [
          1,
          2,
          3,
          4,
          5,
          6,
          7,
          8,
          9,
          10,
          11,
          12,
          13,
          14,
          15,
          16,
          17,
          18,
          19,
          20,
          21,
          22,
          23,
          24
        ],
        chart_title: "Proposals open"
      },
      proposalsData1: {
        series: [
          {
            data: [
              76.0,
              73.0,
              92.0,
              30.0,
              43.0,
              22.0,
              93.0,
              29.0,
              76.0,
              73.0,
              92.0,
              30.0,
              83.0,
              22.0,
              93.0,
              29.0,
              76.0,
              73.0,
              92.0,
              30.0,
              63.0,
              22.0,
              93.0,
              29.0,
              76.0,
              73.0,
              92.0,
              30.0,
              103.0,
              22.0,
              93.0,
              29.0,
              76.0,
              73.0,
              92.0,
              30.0,
              51.0,
              52.0,
              50.0,
              53.0,
              46.0,
              73.0,
              92.0,
              93.0,
              51.0,
              52.0,
              50.0,
              53.0,
              51.0,
              52.0,
              50.0,
              59.0
            ],
            name: "Won",
            type: "column"
          },
          {
            data: [
              10.0,
              55.0,
              44.0,
              49.0,
              57.0,
              53.0,
              57.0,
              38.0,
              10.0,
              55.0,
              44.0,
              49.0,
              57.0,
              53.0,
              57.0,
              38.0,
              55.0,
              44.0,
              49.0,
              57.0,
              53.0,
              57.0,
              38.0,
              89.0,
              10.0,
              55.0,
              44.0,
              49.0,
              57.0,
              53.0,
              57.0,
              38.0,
              10.0,
              55.0,
              44.0,
              49.0,
              57.0,
              53.0,
              57.0,
              38.0,
              55.0,
              44.0,
              49.0,
              57.0,
              53.0,
              57.0,
              38.0,
              89.0,
              49.0,
              57.0,
              53.0,
              57.0
            ],
            name: "Open",
            type: "column"
          },
          {
            data: [
              20.0,
              30.0,
              12.0,
              18.0,
              25.0,
              31.0,
              21.0,
              39.0,
              20.0,
              30.0,
              12.0,
              18.0,
              25.0,
              31.0,
              21.0,
              39.0,
              20.0,
              30.0,
              12.0,
              18.0,
              25.0,
              31.0,
              21.0,
              39.0,
              20.0,
              30.0,
              12.0,
              18.0,
              25.0,
              31.0,
              21.0,
              39.0,
              20.0,
              30.0,
              12.0,
              18.0,
              25.0,
              31.0,
              21.0,
              39.0,
              20.0,
              30.0,
              12.0,
              18.0,
              25.0,
              31.0,
              21.0,
              39.0,
              25.0,
              31.0,
              21.0,
              39.0
            ],
            name: "Lost",
            type: "column"
          }
        ],
        x_axis: [
          1,
          2,
          3,
          4,
          5,
          6,
          7,
          8,
          9,
          10,
          11,
          12,
          13,
          14,
          15,
          16,
          17,
          18,
          19,
          20,
          21,
          22,
          23,
          24,
          25,
          26,
          27,
          28,
          29,
          30,
          31,
          32,
          33,
          34,
          35,
          36,
          37,
          38,
          39,
          40,
          41,
          42,
          43,
          44,
          45,
          46,
          47,
          48,
          49,
          50,
          51,
          52
        ]
      },
      proposalsData2: {
        series: [
          {
            data: [
              76.0,
              73.0,
              92.0,
              30.0,
              43.0,
              22.0,
              93.0,
              29.0,
              76.0,
              73.0,
              92.0,
              30.0,
              83.0,
              22.0,
              93.0,
              29.0,
              76.0,
              73.0,
              92.0,
              30.0,
              63.0,
              22.0,
              93.0,
              29.0,
              76.0,
              73.0,
              92.0,
              30.0,
              103.0,
              22.0,
              93.0,
              29.0,
              76.0,
              73.0,
              92.0,
              30.0,
              51.0,
              52.0,
              50.0,
              53.0,
              46.0,
              73.0,
              92.0,
              93.0,
              51.0,
              52.0,
              50.0,
              53.0,
              51.0,
              52.0,
              50.0,
              59.0
            ],
            name: "Won",
            type: "line"
          },
          {
            data: [
              10.0,
              55.0,
              44.0,
              49.0,
              57.0,
              53.0,
              57.0,
              38.0,
              10.0,
              55.0,
              44.0,
              49.0,
              57.0,
              53.0,
              57.0,
              38.0,
              55.0,
              44.0,
              49.0,
              57.0,
              53.0,
              57.0,
              38.0,
              89.0,
              10.0,
              55.0,
              44.0,
              49.0,
              57.0,
              53.0,
              57.0,
              38.0,
              10.0,
              55.0,
              44.0,
              49.0,
              57.0,
              53.0,
              57.0,
              38.0,
              55.0,
              44.0,
              49.0,
              57.0,
              53.0,
              57.0,
              38.0,
              89.0,
              49.0,
              57.0,
              53.0,
              57.0
            ],
            name: "Open",
            type: "line"
          },
          {
            data: [
              20.0,
              30.0,
              12.0,
              18.0,
              25.0,
              31.0,
              21.0,
              39.0,
              20.0,
              30.0,
              12.0,
              18.0,
              25.0,
              31.0,
              21.0,
              39.0,
              20.0,
              30.0,
              12.0,
              18.0,
              25.0,
              31.0,
              21.0,
              39.0,
              20.0,
              30.0,
              12.0,
              18.0,
              25.0,
              31.0,
              21.0,
              39.0,
              20.0,
              30.0,
              12.0,
              18.0,
              25.0,
              31.0,
              21.0,
              39.0,
              20.0,
              30.0,
              12.0,
              18.0,
              25.0,
              31.0,
              21.0,
              39.0,
              25.0,
              31.0,
              21.0,
              39.0
            ],
            name: "Lost",
            type: "line"
          }
        ],
        x_axis: [
          1,
          2,
          3,
          4,
          5,
          6,
          7,
          8,
          9,
          10,
          11,
          12,
          13,
          14,
          15,
          16,
          17,
          18,
          19,
          20,
          21,
          22,
          23,
          24,
          25,
          26,
          27,
          28,
          29,
          30,
          31,
          32,
          33,
          34,
          35,
          36,
          37,
          38,
          39,
          40,
          41,
          42,
          43,
          44,
          45,
          46,
          47,
          48,
          49,
          50,
          51,
          52
        ]
      },
      boxData: {
        series: [
          {
            value: 1.345,
            title: "New Tasks",
            info: "Information about box 1"
          },
          {
            value: 2.925,
            title: "New Tasks",
            info: "Information about box 2"
          },
          {
            value: 4.585,
            title: "New Tasks",
            info: "Information about box 3"
          }
        ]
      }
    };
  },
  computed: {
    barCountersData() {
      return {
        series: [
          {
            data: [10.0, 55.0, 44.0, 49.0, 57.0, 53.0, 57.0, 50.0],
            name: "Project On",
            type: "column"
          },
          {
            data: [
              4376.0,
              4573.0,
              4792.0,
              4930.0,
              5103.0,
              5222.0,
              5093.0,
              5122.0
            ],
            name: "Project Two",
            type: "column"
          },
          {
            data: [120.0, 130.0, 112.0, 118.0, 125.0, 131.0, 121.0, 125.0],
            name: "Project Three",
            type: "column"
          },
          {
            data: [20.0, 30.0, 12.0, 18.0, 25.0, 31.0, 21.0, 25.0],
            name: "Project Four",
            type: "column"
          }
        ],
        x_axis: ["2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020"]
      };
    },
    barCountersOption() {
      return {
        colors: ["#FA8282", "#FACC82", "#FAF582", "#5dc355"],
        chart: {
          height: 350,
          type: "line",
          stacked: false
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          width: this.barCountersData.series.map(x => {
            if (x.type === "line") {
              return 2;
            } else {
              return 1;
            }
          })
        },
        xaxis: {
          categories: this.barCountersData.x_axis,
          crosshairs: {
            show: true
          },
          tooltip: {
            enabled: true
          }
        },
        yaxis: this.barCountersData.series.map((x, index) => {
          return {
            show: false, // Y-AXIS SHOW
            seriesName: x.name,
            opposite: index >= 1,
            axisTicks: {
              show: true
            },
            axisBorder: {
              show: true,
              color: this.chartColors[index]
            },
            labels: {
              style: {
                colors: this.chartColors[index]
              }
            },
            title: {
              text: x.name,
              style: {
                color: this.chartColors[index]
              }
            }
          };
        }),
        grid: {
          yaxis: {
            lines: {
              show: false
            }
          },
          xaxis: {
            lines: {
              show: false
            }
          }
        },
        tooltip: {
          enabled: true
        },
        legend: {
          show: false
        },
        plotOptions: {
          bar: {
            columnWidth: "30%"
          }
        }
      };
    },
    barVerticalData() {
      return {
        series: [
          {
            data: [120.0, 130.0, 112.0, 118.0, 125.0, 131.0, 121.0, 125.0],
            name: "Project One",
            type: "column"
          },
          {
            data: [20.0, 30.0, 12.0, 18.0, 25.0, 31.0, 21.0, 25.0],
            name: "Project Two",
            type: "column"
          }
        ],
        x_axis: ["2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020"]
      };
    },
    barVerticalOption() {
      return {
        title: {
          text: "Conversion History",
          align: "left",
          offsetX: 5
        },
        colors: ["#FA8282", "#5dc355"],
        chart: {
          type: "line",
          stacked: false
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          width: this.barCountersData.series.map(x => {
            if (x.type === "line") {
              return 2;
            } else {
              return 1;
            }
          })
        },
        xaxis: {
          categories: this.barCountersData.x_axis,
          crosshairs: {
            show: true
          },
          tooltip: {
            enabled: true
          }
        },
        yaxis: {
          show: false
        },
        grid: {
          yaxis: {
            lines: {
              show: false
            }
          },
          xaxis: {
            lines: {
              show: false
            }
          }
        },
        tooltip: {
          enabled: true
        },
        legend: {
          show: false
        },
        plotOptions: {
          bar: {
            columnWidth: "15%"
          }
        }
      };
    },
    barWithWaveData1() {
      return {
        series: [
          {
            name: "Real",
            data: [4, 2, 4, 3, 4, 2, 4, 3, 2, 5, 3, 4],
            type: "column"
          },
          {
            name: "Forecast",
            data: [6, 4, 4, 3, 6, 2, 4, 3, 2, 6, 3, 4],
            type: "column"
          },
          {
            name: "",
            data: [11, 12, 15, 12, 14, 12, 11, 10, 11, 12, 15, 12],
            type: "line"
          }
        ],
        x_axis: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec"
        ]
      };
    },
    barWithWaveOption1() {
      return {
        title: {
          text: "Monthly sales vs Budget",
          align: "left",
          offsetX: 5
        },
        colors: [
          "#5dc355",
          "#ff3b00",
          "#008FFB",
          "#5dc355",
          "#facc82",
          "#ff3b00"
        ],
        chart: {
          type: "line",
          stacked: false
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          width: this.barWithWaveData1.series.map(x => {
            if (x.type === "line") {
              return 2;
            } else {
              return 1;
            }
          }),
          curve: "smooth"
        },
        xaxis: {
          categories: this.barWithWaveData1.x_axis
        },
        yaxis: {
          show: false // Y-AXIS SHOW
        },
        grid: {
          yaxis: {
            lines: {
              show: false
            }
          },
          xaxis: {
            lines: {
              show: false
            }
          }
        },
        tooltip: {
          enabled: true
        },
        legend: {
          show: true,
          horizontalAlign: "left",
          position: "top"
        },
        plotOptions: {
          bar: {
            columnWidth: "15%"
          }
        }
      };
    },
    barWithWaveData2() {
      return {
        series: [
          {
            name: "Project one",
            data: [4, 2, 4, 3, 4, 2, 4, 3, 2, 5, 3, 4],
            type: "column"
          },
          {
            name: "Project two",
            data: [6, 4, 4, 3, 6, 2, 4, 3, 2, 6, 3, 4],
            type: "column"
          },
          {
            name: "Project three",
            data: [6, 4, 4, 3, 6, 2, 4, 3, 2, 6, 3, 4],
            type: "column"
          },
          {
            name: "",
            data: [11, 12, 15, 12, 14, 12, 11, 10, 11, 12, 15, 12],
            type: "line"
          }
        ],
        x_axis: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec"
        ]
      };
    },
    barWithWaveOption2() {
      return {
        title: {
          text: "Project in Execution",
          align: "left",
          offsetX: 5
        },
        colors: [
          "#5dc355",
          "#ff3b00",
          "#facc82",
          "#008FFB",
          "#5dc355",
          "#facc82",
          "#ff3b00"
        ],
        chart: {
          type: "line",
          stacked: false
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          width: 2,
          curve: "smooth"
        },
        xaxis: {
          categories: this.barWithWaveData1.x_axis
        },
        yaxis: {
          show: false // Y-AXIS SHOW
        },
        grid: {
          yaxis: {
            lines: {
              show: false
            }
          },
          xaxis: {
            lines: {
              show: false
            }
          }
        },
        tooltip: {
          enabled: true
        },
        legend: {
          show: true,
          horizontalAlign: "left",
          position: "top"
        },
        plotOptions: {
          bar: {
            columnWidth: "25%"
          }
        }
      };
    },
    counterGraphData() {
      return {
        series: [
          {
            name: "",
            data: [11, 12, 15, 18, 14, 19, 18, 20, 21, 22, 19, 23],
            type: "line"
          }
        ],
        x_axis: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec"
        ]
      };
    },
    counterGraphOption() {
      return {
        colors: ["#0074ff"],
        chart: {
          type: "line",
          stacked: false,
          toolbar: {
            show: true,
            tools: {
              download: false,
              selection: true,
              zoom: true,
              zoomin: false,
              zoomout: false,
              pan: false,
              reset: true
            }
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          width: this.counterGraphData.series.map(x => {
            if (x.type === "line") {
              return 2;
            } else {
              return 1;
            }
          }),
          curve: "smooth"
        },
        xaxis: {
          labels: {
            show: false
          },
          axisBorder: {
            show: false
          },
          axisTicks: {
            show: false
          }
          // categories: this.barWithWaveData1.x_axis
        },
        yaxis: {
          show: false // Y-AXIS SHOW
        },
        grid: {
          yaxis: {
            lines: {
              show: false
            }
          },
          xaxis: {
            lines: {
              show: false
            }
          }
        },
        tooltip: {
          enabled: false
        },
        legend: {
          show: false,
          horizontalAlign: "left",
          position: "top"
        },
        plotOptions: {
          bar: {
            columnWidth: "15%"
          }
        }
      };
    },
    pieSeries() {
      return {
        series: [22000, 8400, 18600, 15300],
        labels: [
          "Marketing Channels",
          "Direct Sales",
          "Offline Channels",
          "Other Channels"
        ],
        chart_title: "Income Breakdown",
        chart_info: "Information about Pie chart"
      };
    },
    pieBasicSeries() {
      return {
        series: [610, 320]
      };
    },
    pieBasicOptions() {
      return {
        colors: ["#66DA26", "#ff3b00"],
        title: {
          text: "Sales",
          align: "left",
          offsetX: 5
        },
        chart: {
          type: "donut"
        },
        labels: ["Real", "Budget"],
        legend: {
          show: true,
          position: "bottom",
          horizontalAlign: "left"
        },
        plotOptions: {
          pie: {
            donut: {
              labels: {
                show: true,
                value: {
                  show: true,
                  fontSize: 36,
                  formatter: function(val, opt) {
                    var total = opt.config.series.reduce(function(acc, val) {
                      return acc + val;
                    }, 0);
                    return `${Math.round((val / total) * 100)}%`;
                  }
                },
                total: {
                  show: true,
                  fontSize: 15,
                  formatter: val => {
                    var total = val.globals.series.reduce((acc, val) => {
                      return acc + val;
                    }, 0);
                    return this.kFormatter(total);
                  }
                }
              }
            }
          }
        },
        dataLabels: {
          enabled: false
        }
      };
    },
    chartColors() {
      return [
        "#008FFB",
        "#66DA26",
        "#FEB019",
        "#FF4560",
        "#E91E63",
        "#546E7A",
        "#00E396"
      ];
    },
    multiChartOption() {
      return {
        colors: this.chartColors,
        title: {
          text: "Multi Chart",
          align: "left",
          offsetX: 70
        },
        chart: {
          height: 350,
          type: "line",
          stacked: false
        },
        dataLabels: {
          enabled: true
        },
        stroke: {
          width: this.proposalsData.series.map(x => {
            if (x.type === "line") {
              return 2;
            } else {
              return 1;
            }
          })
        },
        xaxis: {
          categories: this.proposalsData.x_axis
        },
        yaxis: this.proposalsData.series.map((x, index) => {
          return {
            show: true, // Y-AXIS SHOW
            seriesName: x.name,
            opposite: index >= 1,
            axisTicks: {
              show: true
            },
            axisBorder: {
              show: true,
              color: this.chartColors[index]
            },
            labels: {
              style: {
                colors: this.chartColors[index]
              }
            },
            title: {
              text: x.name,
              style: {
                color: this.chartColors[index]
              }
            }
          };
        }),
        grid: {
          yaxis: {
            lines: {
              show: true
            }
          },
          xaxis: {
            lines: {
              show: true
            }
          }
        },
        tooltip: {
          fixed: {
            enabled: true,
            position: "topLeft",
            offsetY: 30,
            offsetX: 80
          }
        },
        legend: {
          horizontalAlign: "left",
          offsetX: 40
        }
      };
    },
    proposalsChartColor() {
      return ["#14b7ff", "#0074ff", "#00f7f7"];
    },
    waveData() {
      return {
        series: [
          {
            name: "series1",
            data: [31, 20, 35, 49, 32, 20, 40, 30]
          },
          {
            name: "series2",
            data: [11, 32, 45, 32, 34, 52, 41, 20]
          }
        ],
        x_axis: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug"]
      };
    },
    waveColor() {
      return [
        "#008FFB",
        "#ff3b00",
        "#FEB019",
        "#FF4560",
        "#E91E63",
        "#546E7A",
        "#00E396"
      ];
    },
    waveOptions() {
      return {
        colors: this.waveColor,
        title: {
          text: "Orders",
          align: "left",
          offsetX: 15
        },
        chart: {
          height: 350,
          type: "area"
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: "smooth",
          width: 2
        },
        xaxis: {
          categories: this.waveData.x_axis
        },
        tooltip: {
          x: {
            format: "dd/MM/yy HH:mm"
          }
        },
        legend: {
          show: false
        },
        yaxis: {
          show: false
        },
        grid: {
          yaxis: {
            lines: {
              show: false
            }
          },
          xaxis: {
            lines: {
              show: true
            }
          }
        }
      };
    },
    proposalsChartColor1() {
      return ["#5dc355", "#facc82", "#ff3b00"];
    },
    proposalsOption1() {
      return {
        colors: this.proposalsChartColor1,
        chart: {
          id: "fb1",
          type: "line",
          stacked: false,
          group: "social",
          toolbar: {
            show: false
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          width: this.proposalsData1.series.map(x => {
            if (x.type === "line") {
              return 2;
            } else {
              return 1;
            }
          })
        },
        xaxis: {
          categories: this.proposalsData1.x_axis
        },
        yaxis: {
          show: false
        },
        grid: {
          yaxis: {
            lines: {
              show: false
            }
          },
          xaxis: {
            lines: {
              show: false
            }
          }
        },
        tooltip: {
          enabled: true
        },
        legend: {
          show: false
        },
        plotOptions: {
          bar: {
            columnWidth: "40%"
          }
        }
      };
    },
    proposalsOption2() {
      return {
        colors: this.proposalsChartColor1,
        title: {
          text: "Proposals",
          align: "left",
          offsetX: 10
        },
        chart: {
          id: "fb1",
          type: "line",
          stacked: false,
          group: "social"
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          width: this.proposalsData2.series.map(x => {
            if (x.type === "line") {
              return 2;
            } else {
              return 1;
            }
          }),
          show: true,
          curve: "smooth"
        },
        xaxis: {
          categories: this.proposalsData2.x_axis,
          labels: {
            show: false
          },
          axisBorder: {
            show: false
          },
          axisTicks: {
            show: false
          },
          crosshairs: {
            show: false
          },
          tooltip: {
            enabled: false
          }
        },
        yaxis: {
          show: false // Y-AXIS SHOW
        },
        grid: {
          yaxis: {
            lines: {
              show: false
            }
          },
          xaxis: {
            lines: {
              show: false
            }
          }
        },
        tooltip: {
          enabled: true,
          marker: {
            show: true
          }
        },
        legend: {
          position: "top",
          horizontalAlign: "left",
          offsetX: 0
        }
      };
    },
    stackedChartColor() {
      return ["#5dc355", "#facc82", "#ff3b00"];
    },
    stackedChart() {
      return {
        series: [
          {
            name: "Project one",
            data: [44, 55, 41, 67, 22, 43, 21, 49, 41, 67, 22, 43]
          },
          {
            name: "Project two",
            data: [13, 23, 20, 18, 13, 27, 33, 12, 13, 23, 20, 18]
          },
          {
            name: "Project three",
            data: [21, 27, 25, 15, 31, 14, 25, 33, 27, 25, 14, 25]
          }
        ],
        x_axis: {
          categories: [
            "Jan-20",
            "Feb-20",
            "Mar-20",
            "Apr-20",
            "May-20",
            "Jun-20",
            "Jul-20",
            "Aug-20",
            "Sep-20",
            "Oct-20",
            "Nov-20",
            "Dec-20"
          ]
        }
      };
    },
    stackedOptions() {
      return {
        colors: this.stackedChartColor,
        title: {
          text: "Projects in Execution",
          align: "left",
          offsetX: 15
        },
        plotOptions: {
          bar: {
            startingShape: "rounded",
            endingShape: "rounded",
            columnWidth: "15%"
          }
        },
        chart: {
          type: "bar",
          height: 400,
          stacked: true,
          stackType: "100%"
        },
        stroke: {
          width: this.proposalsData.series.map(x => {
            if (x.type === "line") {
              return 3;
            } else {
              return 1;
            }
          })
        },
        xaxis: this.stackedChart.x_axis,
        legend: {
          show: true,
          position: "top",
          horizontalAlign: "left",
          offsetX: -10,
          markers: {
            radius: 12
          }
        },
        grid: {
          yaxis: {
            lines: {
              show: false
            }
          },
          xaxis: {
            lines: {
              show: false
            }
          }
        },
        yaxis: {
          show: false
        },
        dataLabels: {
          enabled: false
        }
      };
    },
    convertionChartData() {
      return {
        series: [
          {
            data: [
              76.0,
              73.0,
              92.0,
              30.0,
              43.0,
              22.0,
              93.0,
              29.0,
              76.0,
              73.0,
              92.0,
              30.0,
              83.0,
              22.0,
              93.0,
              29.0,
              76.0,
              73.0,
              92.0,
              30.0,
              63.0,
              22.0,
              93.0,
              29.0,
              76.0,
              73.0,
              92.0,
              30.0,
              103.0,
              22.0,
              93.0,
              29.0,
              76.0,
              73.0,
              92.0,
              30.0,
              51.0,
              52.0,
              50.0,
              53.0,
              46.0,
              73.0,
              92.0,
              93.0,
              51.0,
              52.0,
              50.0,
              53.0,
              51.0,
              52.0,
              50.0,
              59.0
            ],
            name: "Contacts",
            type: "line"
          },
          {
            data: [
              10,
              25,
              44,
              49,
              27,
              23,
              27,
              38,
              40,
              55,
              44,
              49,
              27,
              33,
              47,
              38,
              35,
              44,
              49,
              27,
              53,
              57,
              38,
              29,
              10,
              55,
              44,
              49,
              57,
              53,
              57,
              38,
              10,
              55,
              44,
              49,
              57,
              53,
              57,
              38,
              55,
              44,
              49,
              57,
              53,
              57,
              38,
              89,
              49,
              57,
              53,
              57
            ],
            name: "Answers",
            type: "line"
          },
          {
            data: [
              220,
              230,
              212,
              218,
              225,
              231,
              221,
              239,
              220,
              230,
              212,
              218,
              225,
              231,
              221,
              239,
              220,
              230,
              212,
              218,
              225,
              231,
              221,
              239,
              220,
              230,
              212,
              218,
              225,
              231,
              221,
              239,
              220,
              230,
              212,
              218,
              225,
              231,
              221,
              239,
              220,
              230,
              212,
              218,
              225,
              231,
              221,
              239,
              225,
              231,
              221,
              239
            ],
            name: "Qualified Meetings",
            type: "line"
          },
          {
            data: [
              410,
              455,
              444,
              449,
              457,
              453,
              457,
              438,
              410,
              455,
              444,
              449,
              457,
              453,
              457,
              438,
              455,
              444,
              449,
              457,
              453,
              457,
              438,
              489,
              410,
              455,
              444,
              449,
              457,
              453,
              457,
              438,
              410,
              455,
              444,
              449,
              457,
              453,
              457,
              438,
              455,
              444,
              449,
              457,
              453,
              457,
              438,
              489,
              449,
              457,
              453,
              457
            ],
            name: "Proposals",
            type: "line"
          },
          {
            data: [
              420,
              530,
              512,
              518,
              425,
              431,
              521,
              539,
              520,
              330,
              412,
              318,
              425,
              531,
              421,
              339,
              520,
              430,
              412,
              518,
              325,
              431,
              521,
              339,
              420,
              530,
              512,
              339,
              420,
              530,
              512,
              739,
              720,
              730,
              339,
              420,
              530,
              512,
              721,
              739,
              720,
              730,
              339,
              420,
              530,
              512,
              721,
              739,
              725,
              339,
              420,
              530
            ],
            name: "Contracts won",
            type: "line"
          }
        ],
        x_axis: [
          1,
          2,
          3,
          4,
          5,
          6,
          7,
          8,
          9,
          10,
          11,
          12,
          13,
          14,
          15,
          16,
          17,
          18,
          19,
          20,
          21,
          22,
          23,
          24,
          25,
          26,
          27,
          28,
          29,
          30,
          31,
          32,
          33,
          34,
          35,
          36,
          37,
          38,
          39,
          40,
          41,
          42,
          43,
          44,
          45,
          46,
          47,
          48,
          49,
          50,
          51,
          52
        ]
      };
    },
    convertionColors() {
      return [
        "#66DA26",
        "#FACC82",
        "#ff3b00",
        "#14b7ff",
        "#0074ff",
        "#14b7ff",
        "#FAF582",
        "#5DC355"
      ];
    },
    convertionChartOption() {
      return {
        colors: this.convertionColors,
        title: {
          text: "Convertion Rate Weeks",
          align: "left",
          offsetX: 10
        },
        chart: {
          height: 350,
          type: "line",
          stacked: false
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          width: this.convertionChartData.series.map(x => {
            if (x.type === "line") {
              return 2;
            } else {
              return 1;
            }
          }),
          curve: "smooth"
        },
        xaxis: {
          categories: this.convertionChartData.x_axis
        },
        yaxis: {
          show: false // Y-AXIS SHOW
        },
        grid: {
          yaxis: {
            lines: {
              show: false
            }
          },
          xaxis: {
            lines: {
              show: true
            }
          }
        },
        legend: {
          position: "top",
          horizontalAlign: "left",
          offsetX: -15
        }
      };
    },
    geometricChartData() {
      return {
        series: [
          {
            name: "28 July 2018",
            data: [20, 23, 20, 18, 23, 17, 24, 29, 27, 25, 34, 37]
          },
          {
            name: "28 July 2019",
            data: [31, 27, 25, 35, 41, 34, 35, 33, 34, 43, 40, 48]
          },
          {
            name: "28 July 2020",
            data: [64, 55, 51, 57, 52, 43, 61, 49, 41, 40, 39, 43]
          }
        ],
        x_axis: {
          categories: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec"
          ]
        }
      };
    },
    geometricColor() {
      return ["#ff3b00", "#008FFB", "#66DA26"];
    },
    geometricChartOptions() {
      return {
        colors: this.geometricColor,
        title: {
          text: "Orders",
          align: "left",
          offsetX: 15
        },
        chart: {
          type: "area"
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: "straight",
          width: 2
        },
        xaxis: this.geometricChartData.x_axis,
        legend: {
          show: true,
          position: "top",
          horizontalAlign: "left",
          offsetX: -10
        },
        yaxis: {
          show: false
        },
        grid: {
          yaxis: {
            lines: {
              show: false
            }
          },
          xaxis: {
            lines: {
              show: false
            }
          }
        }
      };
    },
    barNumericChart() {
      return {
        currentSales: 378.987,
        totalSales: 600.0,
        year: 2021
      };
    }
  },
  methods: {
    async getMultiData() {
      this.multiChartData = await this.$api.chart.getMultiGraphData();
    }
  }
};
